import React from "react";
import {ButtonCenterWrapper, ButtonOuterWrapper, ButtonWrapper} from "./styles";
import PropTypes from "prop-types";

const MainButton = props => {
    const {label, variant, disabled, onClick} = props;

    return (<ButtonOuterWrapper variant={variant} onClick={disabled || !onClick ? undefined : (e => {
        e.preventDefault();
        onClick();
    })} disabled={disabled}>
        <ButtonCenterWrapper>
            <ButtonWrapper variant={variant} >{label}</ButtonWrapper>
        </ButtonCenterWrapper>
    </ButtonOuterWrapper>);
}

MainButton.propTypes = {
    label: PropTypes.string,
    variant: PropTypes.oneOf(['blue', 'green']),
    disabled: PropTypes.bool,
    onClick: PropTypes.func
}

export default MainButton;
